<template>
  <v-container fluid>
    <v-dialog
      v-model="mainDialgo"
      scrollable
      fullscreen
      max-width="500px"
      transition="dialog-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <!-- v-on="on" -->
        <v-btn
          small
          color="success"
          v-bind="attrs"
          :loading="isloading"
          @click="OpenTranDialog"
          icon
        >
          <v-icon>fas fa-info-circle</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="error white--text">
          {{ Title }} Transactions
          <v-spacer></v-spacer>
          <v-btn
            class="d-print-none"
            dark
            text
            icon
            @click="mainDialgo = false"
          >
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-card flat>
            <v-card-title>
              <!-- {{ TranInfo.FullName }} -->
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-search"
                label="Search"
                single-line
                hide-details
                class="d-print-none"
              ></v-text-field>
              <v-btn
                v-if="Transactions.length"
                icon
                class="d-print-none"
                @click="PrintPage"
                small
                color="success"
              >
                <v-icon>fas fa-print</v-icon>
              </v-btn>
            </v-card-title>

            <v-data-table
              :headers="headers"
              :items="Transactions"
              :search="search"
              :items-per-page="itemPerPage"
            >
              <template v-slot:top>
                <v-toolbar flat color="grey lighten-4">
                  <v-toolbar-title v-if="fromDate != '' && toDate != ''"
                    >{{ fromDate }} --- {{ toDate }}</v-toolbar-title
                  >

                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- <div class="flex-grow-1"></div> -->
                  <searchDate
                    :searching="searching"
                    :SearchFun="OnSearch"
                  ></searchDate>
                  <v-spacer></v-spacer>
                  <div>
                    <cashDisplay
                      :isloading="isloading"
                      :Balance="AvailibleBalanceArray"
                    ></cashDisplay>
                  </div>
                </v-toolbar>
              </template>
              <template v-slot:item.Details="{ item }">
                <slot name="Details" :row="item">
                  {{ item.Details }}
                </slot>
              </template>
              <template v-slot:item.deposit="{ item }">
                <slot name="deposit" :row="item">
                  <template v-if="item.Acc == 'Dr'">
                    {{ Math.abs(item.Amount).toLocaleString() }}
                    {{ item.AmountType | MoneySigns }}
                  </template>
                </slot>
              </template>
              <template v-slot:item.withdraw="{ item }">
                <slot name="withdraw" :row="item">
                  <template v-if="item.Acc == 'Cr'">
                    {{ Math.abs(item.Amount).toLocaleString() }}
                    {{ item.AmountType | MoneySigns }}
                  </template>
                </slot>
              </template>
            </v-data-table>
          </v-card>

          <!-- <div>
          <cashDisplay
            inAmount="Dep"
            outAmount="Wth"
            :isloading="isloading"
            :Balance="InOUtBlc"
          ></cashDisplay>
        </div> -->
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
// import { allReq } from "@/axiosfiles/axios-outh";
import cashDisplay from "@/components/util/displayCash.vue";
import searchDate from "@/components/util/searchDate.vue";
import axios from "axios";
// import { mapGetters } from "vuex";
import { EventBus } from "@/main";
export default {
  components: { cashDisplay, searchDate },
  props: {
    TranInfo: { type: Object, required: true },
    Title: { type: String, required: true },
    BaseURL: { type: String, required: true },
    queryKey: { type: Object, required: true },
    headers: {
      type: Array,
      default: () => [
        {
          text: "Date",
          align: "left",
          value: "date",
        },
        { text: "Details", value: "Details" },
        { text: "Cash Type", value: "AmountType" },
        { text: "Deposit", value: "deposit" },
        { text: "Withdrawal", value: "withdraw", class: "blue--text" },
        { text: "User", value: "User" },
        { text: "Ref", value: "Ref" },
      ],
    },
  },
  data() {
    return {
      mainDialgo: false,
      itemPerPage: 10,
      isloading: false,
      searching: false,
      search: "",
      fromDate: "",
      toDate: "",
      OldBalanceArray: [],
      AvailibleBalanceArray: [],
      Transactions: [],
      EmptyMessage: "",
      dialog: false,
      InOUtBlc: [],
    };
  },
  watch: {},
  methods: {
    async PrintPage() {
      this.itemPerPage = this.Transactions.length;
      await EventBus.Printing(false);
      window.print();
      EventBus.Printing(true);
      this.itemPerPage = 10;
    },
    OpenTranDialog() {
      this.Transactions = [];
      // this.OldBalanceArray = [];
      this.AvailibleBalanceArray = [];
      // this.InOUtBlc = [];

      this.searching = true;
      this.isloading = true;

      this.MultReq()
        .then(result => {
          // console.log(result[0]);
          this.mainDialgo = true;
          this.isloading = false;
          this.Transactions = result[0].data;
          // this.OldBalanceArray = result[1].data;
          this.AvailibleBalanceArray = result[1].data;
          // this.InOUtBlc = result[3].data;

          this.searching = false;
        })
        .catch(() => {
          this.isloading = false;
          // console.log(error);
          this.searching = false;
        });
    },
    OldBalane() {
      return this.$store.dispatch("FIND_BY_VALUE", {
        url: `${this.BaseURL}/balance`,
        query: {
          ...this.queryKey,
          from: "",
          to: this.fromDate,
        },
      });
    },
    AvailibleBalance() {
      return this.$store.dispatch("FIND_BY_VALUE", {
        url: `${this.BaseURL}/balance`,
        query: {
          ...this.queryKey,
        },
      });
    },
    TranSactions() {
      return this.$store.dispatch("FIND_BY_VALUE", {
        url: `${this.BaseURL}/transactions`,
        query: {
          ...this.queryKey,
          from: this.fromDate,
          to: this.toDate,
        },
      });
    },
    MultReq() {
      return axios.all([this.TranSactions(), this.AvailibleBalance()]);
    },
    close() {
      this.dialog = false;
    },
    OnSearch(from, to) {
      //   if (this.$refs.form.validate()) {
      this.fromDate = from;
      this.toDate = to;

      this.Transactions = [];
      // this.OldBalanceArray = [];
      this.AvailibleBalanceArray = [];
      // this.InOUtBlc = [];

      this.searching = true;
      this.isloading = true;
      this.$store;
      this.MultReq()
        .then(result => {
          // console.log(result[0]);
          this.isloading = false;
          this.Transactions = result[0].data;
          // this.OldBalanceArray = result[1].data;
          this.AvailibleBalanceArray = result[1].data;
          // this.InOUtBlc = result[3].data;

          this.searching = false;
        })
        .catch(() => {
          this.isloading = false;
          // console.log(error);
          this.searching = false;
        });
    },
  },
  created() {
    // this.LoadCustomerData();
  },
};
</script>
